import { useEffect, useState } from 'react';
import { Icon } from '../../../../layout/Icon.jsx';

const REQUIRED_PHRASE = 'مسح كامل';

export function ConfirmWipeModal({ open, onClose, onConfirm, loading }) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!open) setText('');
  }, [open]);

  if (!open) return null;
  const armed = text.trim() === REQUIRED_PHRASE;

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 grid place-items-center p-4"
    >
      <div className="bg-white rounded-[14px] shadow-pop w-full max-w-[480px] overflow-hidden border-2 border-red">
        <div className="px-5 py-4 border-b border-line flex items-center justify-between bg-red text-white">
          <h3 className="font-extrabold text-[15px] m-0">⚠️ مسح كل البيانات — لا يمكن التراجع</h3>
          <button type="button" onClick={onClose} disabled={loading} className="text-white/80 hover:text-white">
            <Icon name="x" size={18} />
          </button>
        </div>

        <div className="p-5">
          <p className="text-[13px] text-ink leading-relaxed mb-3 font-semibold">
            هذه عملية تدميرية ستحذف كل البيانات بشكل دائم.
          </p>
          <p className="text-[12.5px] text-ink-2 leading-relaxed mb-3">
            سيتم حذف: الأطفال، أولياء الأمور، الكروت، الجلسات، المنتجات، الفواتير، المصاريف،
            حركات المخزون، أحداث البوابات، وكل المستخدمين عدا حسابك الحالي.
          </p>
          <p className="text-[12.5px] text-ink-2 leading-relaxed mb-4">
            سيُبقى: حسابك، الأدوار والصلاحيات الافتراضية، قواعد التسعير، القاصات (برصيد صفر)،
            وفئات المصاريف والإيرادات الافتراضية.
          </p>

          <label className="block text-[12.5px] font-semibold mb-1.5">
            للتأكيد، اكتب <span className="font-mono bg-red/10 text-red px-1.5 py-0.5 rounded">{REQUIRED_PHRASE}</span> في المربع أدناه:
          </label>
          <input
            type="text"
            className="input text-[14px] font-mono"
            placeholder={REQUIRED_PHRASE}
            value={text}
            onChange={(e) => setText(e.target.value)}
            disabled={loading}
            autoFocus
          />
        </div>

        <div className="px-5 py-3 border-t border-line flex items-center justify-end gap-2 bg-paper-2">
          <button type="button" className="btn" onClick={onClose} disabled={loading}>
            إلغاء
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={!armed || loading}
          >
            {loading ? 'جاري المسح…' : 'تأكيد المسح النهائي'}
          </button>
        </div>
      </div>
    </div>
  );
}
